/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type CreateContractTypeV1Dto = {
  /**
   * Contract category for contracts
   */
  category: CreateContractTypeV1Dto.category;
  /**
   * The name of the contract-type.
   */
  name: string;
  /**
   * The order number of the contract-type.
   */
  order: number;
};
export namespace CreateContractTypeV1Dto {
  /**
   * Contract category for contracts
   */
  export enum category {
    SERVICE = 'Service',
  }
}
